import { List, ModelBase, NeoModel } from "@singularsystems/neo-core";
import AuthorisableUpdateRequestLookup from "./AuthorisableUpdateRequestLookup";
import DateTimeHelper from "../../../../../Common/Components/Helpers/DateTimeHelper";

@NeoModel
export default class AuthorisableUpdateRequestBatchLookup extends ModelBase {  

  public authorisableUpdateRequestBatchId: number = 0;

  public userNotes: string = "";

  public serviceProviderName: string = "";

  public numberOfUpdatesInBatch: number = 0;

  public staticServiceProviderId: number = 0;

  public dateCreated: Date | null = null;

  public isExpanded: boolean = false;

  public authorisableUpdateableTableRequestLookups= new List(AuthorisableUpdateRequestLookup);
}